<template>
    <Dialog
        v-bind="attrs"
        :title="dialogTitle"
        :description="dialogDescription"
        modal-width="500px"
        v-on="$listeners"
    >
        <template
            v-for="(_, slot) of $slots"
            #[slot]="scope"
        >
            <slot
                :name="slot"
                v-bind="scope"
            />
        </template>
    </Dialog>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
    mixins: [ dialogMixin ],
    components: {
        Dialog: () => import('@/components/Dialogs/Dialog.vue')
    },
    data () {
        return {
            titleDefault: this.$t('general.deleteConfirmation'),
            descriptionDefault: this.$t('dialog.delete.description')
        }
    },
}
</script>
